import React, { useState } from "react";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { apiurl } from "../config/config";
import { BlackButton } from "../components/buttonContainer";
import { toast } from "react-toastify";
import BackHeader from "../components/backHeader.js";
import { useNavigate } from "react-router-dom";




const CreateTicket = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    store: "",
    vendor: "",
    subject: "",
    category: "",
    subcategory: "",
    description: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const categories = ["Sales", "Technical", "Billing"];
  const subcategories = {
    Sales: ["Inquiry", "Quotation", "Follow-up"],
    Technical: ["Bug Report", "Feature Request", "Support"],
    Billing: ["Invoice Issue", "Payment Query", "Refund Request"],
  };

  const validateForm = () => {
    let formErrors = {};
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        formErrors[key] = `${key} is required.`;
      }
    });
    return formErrors;
  };

  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);

  // console.log("ticketData",ticketData)

  // const fetchTicketData = async (email) => {
  //   setLoading(true); // Start loading
  //   setError(null); // Reset error

  //   try {
  //     const response = await axios.post(
  //       `${apiurl}/admin/v1/ticket/get`,
  //       { email },
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       setTicketData(response.data); // Set the fetched ticket data
  //     } else {
  //       console.error('Failed to fetch ticket data:', response.status);
  //       setError('Failed to fetch ticket data. Please try again.');
  //     }
  //   } catch (err) {
  //     console.error('Error fetching ticket data:', err);
  //     setError('An error occurred. Please try again.');
  //   } finally {
  //     setLoading(false); // End loading
  //   }
  // };

  // useEffect(() => {
  //   if (userData?.email) {
  //     fetchTicketData(userData.email); // Call the function with the email
  //   }
  // }, [userData?.email]); // Re-run only if the email changes

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    console.log("CLICKED")
    console.log("formErrors",formErrors)
    
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors); // Display validation errors
      return; // Stop further execution
    }
  
    setLoading(true); // Start loading
  
    try {
      const response = await axios.post(
        `${apiurl}/admin/v1/ticket/create`,
        formData, // Directly send `formData`
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      if (response.status === 200) {
        // console.log("Ticket Data:", response.data);
        toast.success(response?.data?.message);
        navigate("/support/tickets");
      } else {
        console.error("Failed to fetch ticket data:", response.status);
      }
    } catch (err) {
      console.error("Error fetching ticket data:", err);
    } finally {
      setLoading(false); // End loading
    }
  
    // Reset form data after submission
    setFormData({
      firstname: "",
      lastname: "",
      email: "",
      store: "",
      vendor: "",
      subject: "",
      category: "",
      subcategory: "",
      description: "",
    });
  
    setErrors({}); // Clear errors after successful submission
  };
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="flex justify-center">
          <div className="w-full  bg-white p-8">
            {/* <h1 className="text-2xl font-semibold mb-6 text-center">
              Create New Ticket
            </h1> */}
            <div className="mb-8">
            <BackHeader
                backButton={true}
                link="/support"
                title="Create New Ticket"
              />
            </div>
            <form onSubmit={handleSubmit} className="gap-5 space-y-6 md:space-y-0 md:grid grid-cols-2 ">
            {/* <form  className="space-y-6 grid grid-cols-2"> */}
              {/* First Name */}
              <div>
                <label className="block text-sm md:text-base font-medium text-slate-500 mb-1">
                  First Name *
                </label>
                <input
                  type="text"
                  name="firstname"
                  value={formData.firstname}
                  onChange={handleInputChange}
                  className={`w-full border rounded-lg px-4 py-2 ${
                    errors.firstname ? "border-red-500" : "border-gray-300"
                  }`}
                  placeholder="Enter your first name"
                />
                {errors.firstname && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.firstname}
                  </p>
                )}
              </div>

              {/* Last Name */}
              <div>
                <label className="block text-sm md:text-base font-medium text-slate-500 mb-1">
                  Last Name *
                </label>
                <input
                  type="text"
                  name="lastname"
                  value={formData.lastname}
                  onChange={handleInputChange}
                  className={`w-full border rounded-lg px-4 py-2 ${
                    errors.lastname ? "border-red-500" : "border-gray-300"
                  }`}
                  placeholder="Enter your last name"
                />
                {errors.lastname && (
                  <p className="text-red-500 text-sm mt-1">{errors.lastname}</p>
                )}
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm md:text-base font-medium text-slate-500 mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className={`w-full border rounded-lg px-4 py-2 ${
                    errors.email ? "border-red-500" : "border-gray-300"
                  }`}
                  placeholder="Enter your email address"
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                )}
              </div>

              {/* Store */}
              <div>
                <label className="block text-sm md:text-base font-medium text-slate-500 mb-1">
                  Store *
                </label>
                <input
                  type="text"
                  name="store"
                  value={formData.store}
                  onChange={handleInputChange}
                  className={`w-full border rounded-lg px-4 py-2 ${
                    errors.store ? "border-red-500" : "border-gray-300"
                  }`}
                  placeholder="Enter store name"
                />
                {errors.store && (
                  <p className="text-red-500 text-sm mt-1">{errors.store}</p>
                )}
              </div>

              {/* Vendor */}
              <div>
                <label className="block text-sm md:text-base font-medium text-slate-500 mb-1">
                  Vendor *
                </label>
                <input
                  type="text"
                  name="vendor"
                  value={formData.vendor}
                  onChange={handleInputChange}
                  className={`w-full border rounded-lg px-4 py-2 ${
                    errors.vendor ? "border-red-500" : "border-gray-300"
                  }`}
                  placeholder="Enter vendor name"
                />
                {errors.vendor && (
                  <p className="text-red-500 text-sm mt-1">{errors.vendor}</p>
                )}
              </div>
              {/* Subject */}
              <div>
                <label className="block text-sm md:text-base font-medium text-slate-500 mb-1">
                  Subject *
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className={`w-full border rounded-lg px-4 py-2 ${
                    errors.subject ? "border-red-500" : "border-gray-300"
                  }`}
                  placeholder="Enter subject"
                />
                {errors.subject && (
                  <p className="text-red-500 text-sm mt-1">{errors.subject}</p>
                )}
              </div>

              {/* Category */}
              <div>
                <label className="block text-sm md:text-base font-medium text-slate-500 mb-1">
                  Category *
                </label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  className={`w-full border rounded-lg px-4 py-2 ${
                    errors.category ? "border-red-500" : "border-gray-300"
                  }`}
                >
                  <option value="">Select category</option>
                  {categories.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
                {errors.category && (
                  <p className="text-red-500 text-sm mt-1">{errors.category}</p>
                )}
              </div>

              {/* Subcategory */}
              <div>
                <label className="block text-sm md:text-base font-medium text-slate-500 mb-1">
                  Subcategory *
                </label>
                <select
                  name="subcategory"
                  value={formData.subcategory}
                  onChange={handleInputChange}
                  disabled={!formData.category}
                  className={`w-full border rounded-lg px-4 py-2 ${
                    errors.subcategory ? "border-red-500" : "border-gray-300"
                  }`}
                >
                  <option value="">Select subcategory</option>
                  {formData.category &&
                    subcategories[formData.category].map((subcat) => (
                      <option key={subcat} value={subcat}>
                        {subcat}
                      </option>
                    ))}
                </select>
                {errors.subcategory && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.subcategory}
                  </p>
                )}
              </div>

              {/* Description */}
              <div className="col-span-2">
                <label className="block text-sm md:text-base font-medium text-slate-500 mb-1">
                  Description *
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  className={`w-full border rounded-lg px-4 py-2 ${
                    errors.description ? "border-red-500" : "border-gray-300"
                  }`}
                  rows="4"
                  placeholder="Describe the issue or request"
                ></textarea>
                {errors.description && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.description}
                  </p>
                )}
              </div>

              {/* Submit Button */}
              {/* <div className="text-right">
                <button
                  type="submit"
                  className="bg-blue-600 text-white font-medium px-6 py-2 rounded-lg hover:bg-blue-700"
                >
                  Create Ticket
                </button>
              </div> */}
              <div className="text-center col-span-2">
                <BlackButton type="submit" loading={loading} title="Create Ticket" loadingTitle="Creating"/>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default CreateTicket;
